// extracted by mini-css-extract-plugin
export default {"offersListSkeletonHeader":"offersListSkeletonHeader_G3JGd","item":"item_PPhIg"};